import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { AuthenticationService } from './services/authentication.service';
import { ApplicationService } from './services/application.service';
import { PERMISSIONS } from './models/constants';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private authenticationService:AuthenticationService, private applicationService:ApplicationService) {}

  async ngOnInit() {
    this.isAuthenticated = this.authenticationService.isAuthenticated();
    if(this.isAuthenticated) {
      this.username = this.authenticationService.loginResult.username;
      this.firstName = this.authenticationService.loginResult.firstName;
      this.isAdmin = await this.authenticationService.userHasPermission(PERMISSIONS.ADMIN);
    }
    this.wireEvents();
  }

  isAdmin:boolean = false;
  isAuthenticated:boolean = false;
  username:string = '';
  firstName:string = '';
  title = 'SWING LAB';
  isBusy:boolean = false;
  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  async logout(event: Event) {
    event.preventDefault();
    this.isDropdownOpen = false;
    await this.authenticationService.logout()
    this.router.navigate(['/login']);
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-dropdown')) {
      this.isDropdownOpen = false;
    }
  }

  navigateTo(route: string) {
    this.router.navigate([`/${route}`]);
  }
  
  isActiveRoute(route: string): boolean {
    return this.router.url === `/${route}`;
  }

  private wireEvents() {
    this.authenticationService.authenticationSubscription.subscribe(action => {
      if(action === "LOGIN") {
        this.isAuthenticated = this.authenticationService.isAuthenticated();
        if(this.authenticationService.loginResult.isSuccess) {
          this.username = this.authenticationService.loginResult.username;
          this.firstName = this.authenticationService.loginResult.firstName;
          this.authenticationService.userHasPermission(PERMISSIONS.ADMIN).then(result => ( this.isAdmin = result));
        }
      }
      else if(action === "LOGOUT") {
        this.isAuthenticated = this.authenticationService.isAuthenticated();
        this.username = "";
        this.firstName = "";
        this.router.navigate(['/login']);
      }
    });

    this.applicationService.applicationEventSubscription.subscribe(action => {
      if(action === "SHOWGLOBALSPINNER") {
        this.isBusy = true;
      }
      else if(action === "HIDEGLOBALSPINNER") {
        this.isBusy = false;
      }
    });
  }
}